import styled from 'styled-components';
import Image from '@stencil/image';
import {
  ButtonBase,
  PrimaryLink,
} from '../../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';
import {textSizes} from '@stencil/build-theme';
export const DetailQuickBookWrapper = styled.section(
  props => `
    display: flex;
    flex-direction: column;
    background:#fdf6e9;
    border-radius: ${props.theme.misc.borderRadius.custom(12)};
    padding: ${props.theme.spacing.custom(12)} ${props.theme.spacing.custom(12)} ${
      props.theme.spacing.base
    } ${props.theme.spacing.custom(12)}
    `,
);
export const RoomDetailsWrapper = styled.div(
  props => `
      display:flex;
      justify-content: space-between;
      border-bottom: 1px solid #ffd17c;
      padding-bottom:10px;
      `,
);
export const RoomImage = styled(Image)(
  props => `
      width:100%;
      width:9.1rem;
      height: 8.7rem;
      border-radius:${props.theme.misc.borderRadius.custom(12)};
      object-fit:${props.isDefault ? 'contain' : ''}
      
      `,
);
export const PreviousStayTag = styled.span(
  props => `
  width:111%;
    background-image: linear-gradient(to top, #f4a900, #f8cd46);
    position:absolute;
    top:3px;
    left:-5px;
    padding:1px 5px;
    border-top-right-radius:${props.theme.misc.borderRadius.custom(8)};
    border-top-left-radius:${props.theme.misc.borderRadius.custom(8)};
    text-align: center;
    `,
);
export const RoomImageOuterWrapper = styled.div(
  props => `
    position: relative;
    // width: 52%;
    margin-left:${props.theme.spacing.base};
    margin-bottom:${props.theme.spacing.large};
      
      `,
);
export const NewTagLeftMarkup = styled.span(
  props => `
    &:after {
      content: '';
      border-top: 0.5rem solid #ffe19e;
      border-left: 0.5rem solid transparent;
      position: absolute;
      left: 0;
      top: 1.7rem;
    }
  `,
);
export const NewTagRightMarkup = styled.span(
  props => `
      &:after {
        content: '';
        border-top: 0.5rem solid #ffe19e;
        border-right: 0.5rem solid transparent;
        position: absolute;
        right: 0;
        top: 1.7rem;
      }
    `,
);
export const PreviousStayTextSpan = styled.span(
  props => `
    color:${props.theme.colors.goWhite.base};
    font-size: ${props.theme.font.custom(9)};
    text-align: center;
    font-weight: 600;  
    `,
);
export const RoomKindPara = styled.p`
  ${textSizes.SmallW3}
  margin-bottom:${props => props.theme.spacing.custom(12)};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const RoomDescriptionWrapper = styled.ul(
  props => `
      display:flex;
      flex-direction: column;
      margin-bottom:${props.theme.spacing.base}
      li{
        display:flex;
        align-items: center;
        margin-bottom:${props.theme.spacing.custom(8)};
        &:last-child{
            margin-bottom:${props.theme.spacing.base};
          }
      }
      `,
);
export const RoomFacilityWrapper = styled.ul(
  props => `
        display:flex;
        flex-direction: column;
        border-bottom:1px solid #ffd17c;
        padding: ${props.theme.spacing.xlarge} 0 ${props.theme.spacing.base};
        position:relative;
        li{
          display:flex;
          align-items: center;
          margin-bottom:${props.theme.spacing.custom(8)};
          &:last-child{
              margin-top:${props.theme.spacing.small};
              margin-bottom:0;
            }
        }
        `,
);
export const AmounttobePiad = styled.span(
  props => `
    font-size:${props.theme.spacing.custom(18)};
    font-weight: 600;
    margin-right:${props.theme.spacing.small};
    `,
);
export const PerNeightSpan = styled.span(
  props => `
    color: ${props.theme.colors.downriver.medium};
    `,
);
export const RoomPlanTag = styled.span(
  props => `
    border-radius: 19px;
    background-image: linear-gradient(to top, #1149f3, #00c3ff);
    width:fit-content;
    position: absolute;
    padding: ${props.theme.spacing.custom(2)} ${props.theme.spacing.custom(7)};
    top: -10px;
    color: ${props.theme.colors.goWhite.base};
      `,
);
export const BookingRoomWrapper = styled.div(
  props => `
    display:flex;
    padding:${props.theme.spacing.custom(16)} 0 ${props.theme.spacing.small};
    justify-content:space-between;
    align-items:center;
    `,
);
export const BookNowCTA = styled(ButtonBase)(
  props => `
    padding: ${props.theme.spacing.base} ${props.theme.spacing.large} ${props.theme.spacing.base};
    height:4rem;
    width:50%;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
    border: solid 2px #eb6125;
    border-radius: ${props.theme.misc.borderRadius.custom(25)};
    align-items: center;
    font-size: ${props.theme.font.custom(14)};
    text-transform: none;
  `,
);
export const ViewMoreRoom = styled(PrimaryLink)`
  font-weight: 600;
`;
export const AmenititesTextSpan = styled.span(
  props => `
    color: ${props.theme.colors.downriver.dark}
    `,
);

export const RoomOptionsIconContainer = styled.div(
  props => `
  padding: 0 ${props.theme.spacing.base} 0 0;
`,
);

export const CancellationPolicyContainer = styled.div`
  display: flex;
  flex-direction: column;
  span {
    font-size: 1.2rem;
  }
`;

export const RightDoubleArrowIconContainer = styled.div(
  props => `
    transform: rotate(90deg);
    display: inline-block;
    position: relative;
    top: 0.2rem;
    margin-left: ${props.theme.spacing.custom(4)};
  `,
);

export const PBRoomsAvailablePara = styled.p(
  props => `
    color: ${props.theme.colors.ash.base};
    `,
);
